import { Modal, Spin } from 'antd';
/**
 * Popup lịch trận (cùng nguồn /match/list-match như trang dự đoán), chỉ xem — không nhập tỷ số.
 */
export default function HotScheduleModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={520}
      title={
        <div className="text-center font-black uppercase tracking-wide text-[#111827] text-[15px] md:text-lg pr-6">
          Lịch thi đấu hot
        </div>
      }
      styles={{
        content: { maxWidth: 'calc(100vw - 24px)' },
        body: { maxHeight: 'min(80vh, 600px)', overflowY: 'auto', paddingTop: 8 }
      }}
    >
      <div className="p-4">
        <iframe
          src="https://football-widget.pages.dev/"
          width="100%"
          height="600"
          frameBorder="0"
          allowFullScreen
          title="Football Widget"
          className="w-full rounded-lg"
        />
      </div>
    </Modal>
  );
}
